module.exports = __webpack_public_path__ + "img/tk.1f31ec51.svg";